<template>
  <span :class="['kpi-status-badge', statusKey]">
    {{ displayLabel }}
  </span>
</template>

<script setup>
import { computed } from "vue";

// Backend stores the active status as "Published"; the UI label is "Active".
const STATUS_LABELS = {
  draft: "Draft",
  published: "Active",
  active: "Active",
  retired: "Retired",
  archived: "Archived",
};

const props = defineProps({
  status: {
    type: String,
    required: true,
    validator: (value) =>
      ["draft", "published", "active", "retired", "archived"].includes(value.toLowerCase()),
  },
});

const statusKey = computed(() => {
  const normalized = props.status.toLowerCase();
  return normalized === "published" ? "active" : normalized;
});

const displayLabel = computed(() => STATUS_LABELS[statusKey.value] ?? props.status);
</script>

<style scoped>
.kpi-status-badge {
  --kpi-status-badge-border-width: 1px;
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  height: 22px;
  padding: 0 calc(8px - var(--kpi-status-badge-border-width));
  border: var(--kpi-status-badge-border-width) solid;
  border-radius: 9999px;
  font-family: "Inter", sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
  white-space: nowrap;
}

.draft {
  background-color: var(--component-colors-utility-gray-utility-gray-50, #f9fafb);
  border-color: var(--component-colors-utility-gray-utility-gray-200, #eaecf0);
  color: var(--component-colors-utility-gray-utility-gray-700, #344054);
}

.active {
  background-color: var(--component-colors-utility-success-utility-success-50, #ecfdf3);
  border-color: var(--component-colors-utility-success-utility-success-200, #abefc6);
  color: var(--component-colors-utility-success-utility-success-700, #067647);
}

.retired {
  --kpi-status-badge-border-width: 1.5px;
  background-color: transparent;
  border-color: var(--colors-text-text-tertiary-600, #475467);
  color: var(--component-colors-utility-gray-utility-gray-700, #344054);
}

.archived {
  --kpi-status-badge-border-width: 1.5px;
  background-color: var(--colors-background-bg-error-solid, #d92d20);
  border-color: var(--colors-text-text-tertiary-600, #475467);
  color: var(--White, #fff);
}
</style>
